$(document).ready(function (){

    /*Слайдер Комплект недели*/
    $('.sliderSetOfWeek').slick({
        slidesToShow: 2,
        slidesToScroll: 1,
        arrows: true,
        dots: false,
        infinite: true,
        variableWidth: true,
        responsive: [
            {
                breakpoint: 993,
                settings: {
                    arrows: false,
                    dots: true,
                    slidesToShow: 3,
                    // centerMode: true,
                }
            }
        ]
    });

    if (endDate !== undefined) {
        $("#counterSetOfWeek")
            .countdown(endDate, function(event) {

                /*функция склонения "дней" */
                function dayTitle(number) {
                    if (number > 10 && [11, 12, 13, 14].includes(number%100)) return 'дней';
                    last_num = number%10;
                    if (last_num == 1) return 'день';
                    if ([2,3,4].includes(last_num)) return 'дня';
                    if ([5,6,7,8,9, 0].includes(last_num)) return 'дней';
                }

                /*количество дней*/
                var $c_days_num = event.strftime('%-D');

                var $this = $(this).html(event.strftime(''
                    + '<div class="pt-value">%-D ' + dayTitle($c_days_num) + '</div> '
                    + '<div class="pt-value">%H</div> '
                    + '<div class="pt-value">%M</div> '
                    + '<div class="pt-value">%S</div>'));
            });
    }


    /*$(document).on('click', '#collectSet__btnBuy_block', function (e) {
        e.preventDefault();

        if ($(this).hasClass('added') == false) {

            // слайдер с товарами в комплекте
            let collectSetSlider = $('.setOfWeek');

            // чекбоксы товаров из комплекта
            let collection_chekboxes = collectSetSlider.find('.sliderSetOfWeek__item input');

            // пустой массив, в который соберутся ID всех товаров в комплекте, включая текущий
            let collection_IDs_Array = [];

            // перебор чекбоксов товаров
            collection_chekboxes.each(function (index, element) {

                // ID чекбокса товара
                let collectionProduct_ID = $(element).attr('data-id-collect');

                // проверка выбран ли товар
                let collectSetSliderItem_checked = $(element).is(":checked");

                // добавляем в итоговый массив, если товар выбран
                if (collectSetSliderItem_checked) {
                    collection_IDs_Array.push(collectionProduct_ID);
                }
            });

            // вывод в консоль массива ID выбранных товаров из комплекта
            BX.ajax.post(
                '/ajax/addCollection.php',
                {productsIds: collection_IDs_Array},
                function() {
                    $('#collectSet__btnBuy_block').attr('disabled', 'disabled')
                }
            );

            BX.addCustomEvent( 'onAjaxSuccess' ,   function  () {
                $(this).html('Перейти в корзину');
                $(this).addClass('added');

                BX.onCustomEvent('OnBasketChange');
                $('#collectSet__btnBuy_block').removeAttribute('disabled')
            });

        } else {
            window.location.href = '/cart/';
        }
    });*/
});
